// removed by extract-text-webpack-plugin
module.exports = {"companies":"Companies__companies___XNIHb","companiesItem":"Companies__companiesItem___2HC0c"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing2/components/Companies.scss
// module id = 1803
// module chunks = 0